<ng-container *transloco="let t">
  @if (currentApplicationFormSettings) {
    <form #applicationForm="ngForm">
      <!--                        Personal data card-->
      <app-admin-card-with-title
        [cardTitle]="t('race.registration.settings.standard.fields')" [showToggleButton]="true"
        [removeTopMargin]="true">
        <div class="row">
          <div class="col-12 col-md-6 col-xl-4 col-xxl-3 pb-3">
            <app-race-details-registration-settings-default-field-form [title]="t('app.common.first.name')"
                                                                       [visibilityTypes]="visibilityTypes"
                                                                       [registrationDisplayFlags]="registrationDisplayFlags"
                                                                       [disabled]="true"
                                                                       [applicationFromSettings]="currentApplicationFormSettings"
                                                                       [tooltip]="!disableEditing ? t('race.registration.settings.predefined.tooltip'): undefined"
                                                                       [visibilityKey]="'nameVisibility'"
                                                                       [registrationDisplayFlagKey]="'nameRegistrationDisplayFlag'"
                                                                       [requiredKey]="'nameRequired'"/>
          </div>
          <div class="col-12 col-md-6 col-xl-4 col-xxl-3 pb-3">
            <app-race-details-registration-settings-default-field-form [title]="t('app.common.last.name')"
                                                                       [visibilityTypes]="visibilityTypes"
                                                                       [registrationDisplayFlags]="registrationDisplayFlags"
                                                                       [disabled]="true"
                                                                       [applicationFromSettings]="currentApplicationFormSettings"
                                                                       [tooltip]="!disableEditing ? t('race.registration.settings.predefined.tooltip'): undefined"
                                                                       [visibilityKey]="'lastnameVisibility'"
                                                                       [registrationDisplayFlagKey]="'lastnameRegistrationDisplayFlag'"
                                                                       [requiredKey]="'lastnameRequired'"/>
          </div>
          <div class="col-12 col-md-6 col-xl-4 col-xxl-3 pb-3">
            <app-race-details-registration-settings-default-field-form [title]="t('app.common.email')"
                                                                       [tooltip]="!disableEditing ? t('race.registration.settings.predefined.tooltip'): undefined"
                                                                       [visibilityTypes]="visibilityTypes"
                                                                       [registrationDisplayFlags]="registrationDisplayFlags"
                                                                       [applicationFromSettings]="currentApplicationFormSettings"
                                                                       [visibilitySelectionDisabled]="true"
                                                                       [registrationDisplayFlagSelectionDisabled]="true"
                                                                       [requiredSelectionDisabled]="true"
                                                                       [disabled]="true"
                                                                       [visibilityKey]="'emailVisibility'"
                                                                       [registrationDisplayFlagKey]="'emailRegistrationDisplayFlag'"
                                                                       [requiredKey]="'emailRequired'"/>
          </div>
          <div class="col-12 col-md-6 col-xl-4 col-xxl-3 pb-3">
            <app-race-details-registration-settings-default-field-form [title]="t('app.common.gender')"
                                                                       [visibilityTypes]="visibilityTypes"
                                                                       [registrationDisplayFlags]="registrationDisplayFlags"
                                                                       [disabled]="genderDisabled || disableEditing"
                                                                       [applicationFromSettings]="currentApplicationFormSettings"
                                                                       [tooltip]="!disableEditing && genderDisabled? t('race.registration.settings.gender.tooltip') : undefined"
                                                                       [visibilityKey]="'genderVisibility'"
                                                                       [registrationDisplayFlagKey]="'genderRegistrationDisplayFlag'"
                                                                       [requiredKey]="'genderRequired'"/>
          </div>
          <div class="col-12 col-md-6 col-xl-4 col-xxl-3 pb-3">
            <app-race-details-registration-settings-default-field-form
              [publicVisibilitySelectionDisabled]="true"
              [title]="t('race.registration.settings.nickname')" [visibilityTypes]="visibilityTypes"
              [registrationDisplayFlags]="registrationDisplayFlags" [disabled]="disableEditing"
              [applicationFromSettings]="currentApplicationFormSettings" [visibilityKey]="'nicknameVisibility'"
              [registrationDisplayFlagKey]="'nicknameRegistrationDisplayFlag'" [requiredKey]="'nicknameRequired'"/>
          </div>
          <div class="col-12 col-md-6 col-xl-4 col-xxl-3 pb-3">
            <app-race-details-registration-settings-default-field-form
              [title]="t('race.registration.settings.dayOfBirth')"
              [registrationDisplayFlags]="registrationDisplayFlags" [disabled]="disableEditing|| birthdayDisabled"
              [tooltip]="birthdayDisabled && !disableEditing? t('race.registration.settings.dayOfBirth.tooltip'): undefined"
              [applicationFromSettings]="currentApplicationFormSettings"
              [registrationDisplayFlagKey]="'birthdayRegistrationDisplayFlag'" [requiredKey]="'birthdayRequired'"/>
          </div>
          <div class="col-12 col-md-6 col-xl-4 col-xxl-3 pb-3">
            <app-race-details-registration-settings-default-field-form [title]="t('race.registration.settings.address')"
                                                                       [publicVisibilitySelectionDisabled]="true"
                                                                       [visibilityTypes]="visibilityTypes"
                                                                       [registrationDisplayFlags]="registrationDisplayFlags"
                                                                       [disabled]="disableEditing"
                                                                       [applicationFromSettings]="currentApplicationFormSettings"
                                                                       [visibilityKey]="'addressVisibility'"
                                                                       [registrationDisplayFlagKey]="'addressRegistrationDisplayFlag'"
                                                                       [requiredKey]="'addressRequired'"/>
          </div>

          <div class="col-12 col-md-6 col-xl-4 col-xxl-3 pb-3">
            <app-race-details-registration-settings-default-field-form
              [title]="t('race.registration.settings.cityOrPlace')" [visibilityTypes]="visibilityTypes"
              [publicVisibilitySelectionDisabled]="true"
              [registrationDisplayFlags]="registrationDisplayFlags" [disabled]="disableEditing"
              [applicationFromSettings]="currentApplicationFormSettings" [visibilityKey]="'cityVisibility'"
              [registrationDisplayFlagKey]="'cityRegistrationDisplayFlag'" [requiredKey]="'cityRequired'"/>
          </div>

          <div class="col-12 col-md-6 col-xl-4 col-xxl-3 pb-3">
            <app-race-details-registration-settings-default-field-form [title]="t('race.registration.settings.country')"
                                                                       [visibilityTypes]="visibilityTypes"
                                                                       [registrationDisplayFlags]="registrationDisplayFlags"
                                                                       [disabled]="disableEditing"
                                                                       [applicationFromSettings]="currentApplicationFormSettings"
                                                                       [visibilityKey]="'countryVisibility'"
                                                                       [registrationDisplayFlagKey]="'countryRegistrationDisplayFlag'"
                                                                       [requiredKey]="'countryRequired'"/>
          </div>
          <div class="col-12 col-md-6 col-xl-4 col-xxl-3 pb-3">
            <app-race-details-registration-settings-default-field-form
              [title]="t('race.registration.settings.nationality')" [visibilityTypes]="visibilityTypes"
              [publicVisibilitySelectionDisabled]="true"
              [registrationDisplayFlags]="registrationDisplayFlags" [disabled]="disableEditing"
              [applicationFromSettings]="currentApplicationFormSettings" [visibilityKey]="'nationalityVisibility'"
              [registrationDisplayFlagKey]="'nationalityRegistrationDisplayFlag'"
              [requiredKey]="'nationalityRequired'"/>
          </div>

          <div class="col-12 col-md-6 col-xl-4 col-xxl-3 pb-3">
            <app-race-details-registration-settings-default-field-form
              [title]="t('race.registration.settings.identificationNumber')" [visibilityTypes]="visibilityTypes"
              [publicVisibilitySelectionDisabled]="true"
              [registrationDisplayFlags]="registrationDisplayFlags" [disabled]="disableEditing"
              [applicationFromSettings]="currentApplicationFormSettings"
              [visibilityKey]="'identityCardNumberVisibility'"
              [registrationDisplayFlagKey]="'identityCardNumberRegistrationDisplayFlag'"
              [requiredKey]="'identityCardNumberRequired'"
              [emitRegistrationDisplayFlagValueChanges]="true"
              (registrationDisplayFlagValueChange)="identityCardDisplayFlagValueChange($event)"/>
          </div>

          <div class="col-12 col-md-6 col-xl-4 col-xxl-3 pb-3">
            <app-race-details-registration-settings-default-field-form
              [title]="t('race.registration.settings.identificationExpires')" [visibilityTypes]="visibilityTypes"
              [publicVisibilitySelectionDisabled]="true"
              [registrationDisplayFlags]="registrationDisplayFlags" [disabled]="disableEditing"
              [applicationFromSettings]="currentApplicationFormSettings"
              [visibilityKey]="'identityCardExpiresVisibility'"
              [registrationDisplayFlagKey]="'identityCardExpiresRegistrationDisplayFlag'"
              [requiredKey]="'identityCardExpiresRequired'"
              [disabled]="identityCardFieldsDisabled"/>
          </div>

          <div class="col-12 col-md-6 col-xl-4 col-xxl-3 pb-3">
            <app-race-details-registration-settings-default-field-form
              [title]="t('race.registration.settings.issuingAuthority')" [visibilityTypes]="visibilityTypes"
              [publicVisibilitySelectionDisabled]="true"
              [registrationDisplayFlags]="registrationDisplayFlags" [disabled]="disableEditing"
              [applicationFromSettings]="currentApplicationFormSettings"
              [visibilityKey]="'identityCardIssuerVisibility'"
              [registrationDisplayFlagKey]="'identityCardIssuerRegistrationDisplayFlag'"
              [requiredKey]="'identityCardIssuerRequired'"
              [disabled]="identityCardFieldsDisabled"/>
          </div>

          <div class="col-12 col-md-6 col-xl-4 col-xxl-3 pb-3">
            <app-race-details-registration-settings-default-field-form
              [title]="t('race.registration.settings.mobilePhone')" [visibilityTypes]="visibilityTypes"
              [publicVisibilitySelectionDisabled]="true"
              [registrationDisplayFlags]="registrationDisplayFlags" [disabled]="disableEditing"
              [applicationFromSettings]="currentApplicationFormSettings" [visibilityKey]="'mobilePhoneVisibility'"
              [registrationDisplayFlagKey]="'mobilePhoneRegistrationDisplayFlag'"
              [requiredKey]="'mobilePhoneRequired'"/>
          </div>

          <div class="col-12 col-md-6 col-xl-4 col-xxl-3 pb-3">
            <app-race-details-registration-settings-default-field-form
              [title]="t('race.registration.settings.emergencyPhone')" [visibilityTypes]="visibilityTypes"
              [publicVisibilitySelectionDisabled]="true"
              [registrationDisplayFlags]="registrationDisplayFlags" [disabled]="disableEditing"
              [applicationFromSettings]="currentApplicationFormSettings" [visibilityKey]="'emergencyPhoneVisibility'"
              [registrationDisplayFlagKey]="'emergencyPhoneRegistrationDisplayFlag'"
              [requiredKey]="'emergencyPhoneRequired'"/>
          </div>
          <div class="col-12 col-md-6 col-xl-4 col-xxl-3 pb-3">
            <app-race-details-registration-settings-default-field-form
              [title]="t('race.registration.settings.ageCategory')" [visibilityTypes]="visibilityTypes"
              [tooltip]="categoryDisabled && !disableEditing? t('race.registration.settings.ageCategory.tooltip'): undefined"
              [registrationDisplayFlags]="registrationDisplayFlags" [disabled]="disableEditing|| categoryDisabled"
              [applicationFromSettings]="currentApplicationFormSettings"
              [visibilityKey]="'categoryRegistrationVisibility'"/>
          </div>

          <div class="col-12 col-md-6 col-xl-4 col-xxl-3 pb-3">
            <app-race-details-registration-settings-default-field-form
              [title]="t('race.registration.settings.clubSchoolTeam')" [visibilityTypes]="visibilityTypes"
              [registrationDisplayFlags]="registrationDisplayFlags" [disabled]="disableEditing"
              [applicationFromSettings]="currentApplicationFormSettings" [visibilityKey]="'clubVisibility'"
              [registrationDisplayFlagKey]="'clubRegistrationDisplayFlag'" [requiredKey]="'clubRequired'"/>
          </div>

          <div class="col-12 col-md-6 col-xl-4 col-xxl-3 pb-3">
            <app-race-details-registration-settings-default-field-form [title]="t('race.registration.settings.tshirt')"
                                                                       [publicVisibilitySelectionDisabled]="true"
                                                                       [visibilityTypes]="visibilityTypes"
                                                                       [registrationDisplayFlags]="registrationDisplayFlags"
                                                                       [applicationFromSettings]="currentApplicationFormSettings"
                                                                       [visibilityKey]="'tshirtVisibility'"
                                                                       [registrationDisplayFlagKey]="'tshirtRegistrationDisplayFlag'"
                                                                       [requiredKey]="'tshirtRequired'"
                                                                       (statusChanged)="fieldStatusChanged($event, 'tshirts')"
                                                                       [disabled]="disableEditing"
                                                                       [optionsList]="tShirtSizes"
                                                                       [optionsKey]="'tshirts'"
                                                                       [dropdownLabel]="t('app.common.options')"
                                                                       [textFieldPlaceholderPrefix]="'race.registration.settings.comment.placeholder'"
                                                                       [textFieldKeySlo]="'tshirtCommentSlo'"
                                                                       [textFieldKeySr]="'tshirtCommentSr'"
                                                                       [textFieldKeyBs]="'tshirtCommentBs'"
                                                                       [textFieldKey]="'tshirtComment'"
                                                                       [textFieldKeyEng]="'tshirtCommentEng'"
                                                                       [textFieldKeyIta]="'tshirtCommentIta'"

            />

          </div>
          <div class="col-12 col-md-6 col-xl-4 col-xxl-3 pb-3">
            <app-race-details-registration-settings-default-field-form [title]="t('race.registration.settings.meal')"
                                                                       [publicVisibilitySelectionDisabled]="true"
                                                                       [visibilityTypes]="visibilityTypes"
                                                                       [registrationDisplayFlags]="registrationDisplayFlags"
                                                                       [disabled]="disableEditing"
                                                                       [applicationFromSettings]="currentApplicationFormSettings"
                                                                       [visibilityKey]="'mealVisibility'"
                                                                       [registrationDisplayFlagKey]="'mealRegistrationDisplayFlag'"
                                                                       [requiredKey]="'mealRequired'"
                                                                       [optionsList]="meals" [optionsKey]="'meals'"
                                                                       (statusChanged)="fieldStatusChanged($event, 'meals')"
                                                                       [dropdownLabel]="t('app.common.options')"
                                                                       [textFieldPlaceholderPrefix]="'race.registration.settings.comment.placeholder'"
                                                                       [textFieldKeySlo]="'mealCommentSlo'"
                                                                       [textFieldKeySr]="'mealCommentSr'"
                                                                       [textFieldKeyBs]="'mealCommentBs'"
                                                                       [textFieldKey]="'mealComment'"
                                                                       [textFieldKeyEng]="'mealCommentEng'"
                                                                       [textFieldKeyIta]="'mealCommentIta'"/>
          </div>
          <div class="col-12 col-md-6 col-xl-4 col-xxl-3 pb-3">
            <app-race-details-registration-settings-default-field-form
              [title]="t('race.registration.settings.transport')" [visibilityTypes]="visibilityTypes"
              [publicVisibilitySelectionDisabled]="true"
              [registrationDisplayFlags]="registrationDisplayFlags" [disabled]="disableEditing"
              [applicationFromSettings]="currentApplicationFormSettings" [visibilityKey]="'transportVisibility'"
              [registrationDisplayFlagKey]="'transportRegistrationDisplayFlag'" [requiredKey]="'transportRequired'"
              [textFieldPlaceholderPrefix]="'race.registration.settings.comment.placeholder'"
              [textFieldKeySlo]="'transportCommentSlo'" [textFieldKey]="'transportComment'"
              [textFieldKeyEng]="'transportCommentEng'"
              [textFieldKeySr]="'transportCommentSr'"
              [textFieldKeyBs]="'transportCommentBs'"
              [textFieldKeyIta]="'transportCommentIta'"/>
          </div>
          <div class="col-12 col-md-6 col-xl-4 col-xxl-3 pb-3">
            <app-race-details-registration-settings-default-field-form
              [title]="t('race.registration.settings.entryFee')" [visibilityTypes]="visibilityTypes"
              [publicVisibilitySelectionDisabled]="true"
              [registrationDisplayFlags]="registrationDisplayFlags" [disabled]="disableEditing"
              [applicationFromSettings]="currentApplicationFormSettings" [visibilityKey]="'feeVisibility'"
            />
          </div>
          <div class="col-12 col-md-6 col-xl-4 col-xxl-3 pb-3">
            <app-race-details-registration-settings-default-field-form
              [title]="t('race.registration.settings.previousBestTime')" [visibilityTypes]="visibilityTypes"
              [publicVisibilitySelectionDisabled]="true"
              [registrationDisplayFlags]="registrationDisplayFlags" [disabled]="disableEditing"
              [applicationFromSettings]="currentApplicationFormSettings" [visibilityKey]="'bestTimeVisibility'"
              [registrationDisplayFlagKey]="'bestTimeRegistrationDisplayFlag'" [requiredKey]="'bestTimeRequired'"/>
          </div>
          <div class="col-12 col-md-6 col-xl-4 col-xxl-3 pb-3">
            <app-race-details-registration-settings-default-field-form [title]="t('race.registration.settings.comment')"
                                                                       [publicVisibilitySelectionDisabled]="true"
                                                                       [visibilityTypes]="visibilityTypes"
                                                                       [registrationDisplayFlags]="registrationDisplayFlags"
                                                                       [disabled]="disableEditing"
                                                                       [applicationFromSettings]="currentApplicationFormSettings"
                                                                       [visibilityKey]="'commentVisibility'"
                                                                       [registrationDisplayFlagKey]="'commentRegistrationDisplayFlag'"
                                                                       [textFieldKey]="'comment'"
                                                                       [textFieldPlaceholderPrefix]="'race.registration.settings.comment.placeholder'"
                                                                       [textFieldKeySlo]="'commentSlo'"
                                                                       [textFieldKeyEng]="'commentEng'"
                                                                       [textFieldKeySr]="'commentSr'"
                                                                       [textFieldKeyBs]="'commentBs'"
                                                                       [textFieldKeyIta]="'commentIta'"/>
          </div>

          <div class="col-12 col-md-6 col-xl-4 col-xxl-3 pb-3">
            <app-race-details-registration-settings-default-field-form
              [title]="t('race.registration.settings.chipNumber')" [visibilityTypes]="visibilityTypes"
              [publicVisibilitySelectionDisabled]="true"
              [publicRegistrationDisplaySelectionDisabled]="true"
              [registrationDisplayFlags]="registrationDisplayFlags"
              [applicationFromSettings]="currentApplicationFormSettings" [visibilityKey]="'chipNumberVisibility'"
              [disabled]="disableEditing" [registrationDisplayFlagKey]="'chipNumberRegistrationDisplayFlag'"
              [requiredKey]="'chipNumberRequired'"/>
          </div>

          <div class="col-12 col-md-6 col-xl-4 col-xxl-3 pb-3">
            <app-race-details-registration-settings-default-field-form [title]="t('race.registration.settings.license')"
                                                                       [publicVisibilitySelectionDisabled]="true"
                                                                       [visibilityTypes]="visibilityTypes"
                                                                       [registrationDisplayFlags]="registrationDisplayFlags"
                                                                       [disabled]="disableEditing"
                                                                       [applicationFromSettings]="currentApplicationFormSettings"
                                                                       [visibilityKey]="'licenceVisibility'"
                                                                       [registrationDisplayFlagKey]="'licenceRegistrationDisplayFlag'"
                                                                       [requiredKey]="'licenceRequired'"/>
          </div>

          <div class="col-12 col-md-6 col-xl-4 col-xxl-3 pb-3">
            <app-race-details-registration-settings-default-field-form
              [title]="t('race.registration.settings.discipline')"
              [publicVisibilitySelectionDisabled]="true"
              [visibilityTypes]="visibilityTypes"
              [registrationDisplayFlags]="registrationDisplayFlags"
              [registrationDisplayFlagSelectionDisabled]="true"
              [requiredSelectionDisabled]="true"
              [disabled]="disableEditing|| disciplineDisabled"
              [applicationFromSettings]="currentApplicationFormSettings"
              [visibilityKey]="'disciplineVisibility'"
              [registrationDisplayFlagKey]="'disciplineRegistrationDisplayFlag'"
              [requiredKey]="'disciplineRequired'"
              [fieldLabel]="t('race.registration.settings.discipline')"
              [tooltip]="disciplineDisabled && !disableEditing? t('race.registration.settings.discipline.tooltip'): undefined"
              [optionsList]="disciplines"
              [optionLabelPrefixKey]="'race.registration.settings.discipline.'"
              [optionsKey]="'disciplines'"
              (statusChanged)="fieldStatusChanged($event, 'disciplines')"
              [dropdownLabel]="t('app.common.options')"/>
          </div>
        </div>
        <div class="d-flex justify-content-end pb-3">
          @if (!isDefaultDataCollapsed) {
            <span class="admin-card__legend">{{ t("race.registration.settings.legend") }}</span>
          }
        </div>
      </app-admin-card-with-title>

      <div class="mt-4">
        <app-admin-card-with-title
          [cardTitle]="t('race.registration.settings.customField.title')" [showToggleButton]="true">
          <div slot="trailingWidget">
            @if (!disableEditing) {
              <div class="pe-4">
                <app-rounded-button [label]="t('race.registration.settings.customField.add')"
                                    (onClick)="openCustomFieldPanel()" [isDisabled]="false"
                                    [btnClass]="'rounded-button--solid'"><i
                  class="bi bi-plus-circle pe-2"></i></app-rounded-button>
              </div>
            }
          </div>
          <div class="row">
            @for (customField of customFields;let idx = $index;track customField) {
              <ng-container>
                <div class="col-12 col-md-6 col-xl-4 col-xxl-3 pb-3">
                  <div (click)="openCustomFieldPanel(customField, idx)">
                    <app-race-details-panel
                      [disabled]="disableEditing"
                      [panelStatus]="!customFieldsValid[idx] ? 'error' :
                                        (((customField.registrationDisplayFlag ?? RegistrationDisplayFlags.NOT_USED) !== RegistrationDisplayFlags.NOT_USED) ||
                                            ((customField.visibility ?? VisibilityTypes.NOT_VISIBLE) !== VisibilityTypes.NOT_VISIBLE) || customField.required) ? 'required' : 'optional'"
                    >
                      <div class="panel-content">
                        <strong class="mb-3 d-inline-block fs-18 trim-text pe-20 line-height-12">
                          <app-language-output [hrLabel]="customField.name" [enLabel]="customField.nameEng" [bsLabel]="customField.nameBs"
                                               [itLabel]="customField.nameIta" [srLabel]="customField.nameSr" [siLabel]="customField.nameSlo"
                                               [defaultLanguage]="event?.defaultLanguage" [languages]="languages"/>
                        </strong>
                        <div>
                          <small
                            [ngClass]="{'fw-bold': customField.registrationDisplayFlag === RegistrationDisplayFlags.ALWAYS_USED}">
                            {{
                              t('race.registration.settings.registrationDisplayFlags.' +
                                (customField.registrationDisplayFlag ?? RegistrationDisplayFlags.NOT_USED.toString()))
                            }}
                          </small>
                        </div>
                        <small>{{
                            t('race.settings.visibilityTypes.' + (customField.visibility
                              ?? VisibilityTypes.NOT_VISIBLE))
                          }}</small>
                      </div>
                    </app-race-details-panel>
                  </div>
                </div>
              </ng-container>
            }
          </div>
          <div class="d-flex justify-content-end pb-3">
            @if (!isCustomDataCollapsed) {
              <span class="admin-card__legend">{{ t("race.registration.settings.legend") }}</span>
            }
          </div>
        </app-admin-card-with-title>
      </div>

      <app-action-buttons-row (onSave)="onSave()" (onCancel)="onCancel()" [cancelVisible]="!disableEditing"
                              [backVisible]="true" [disableEditing]="disableEditing">
      </app-action-buttons-row>
    </form>
  }
</ng-container>
